import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import BaseClickable from 'components/ui/BaseClickable';
import { accessibilityParamsStore } from 'stores/root';

import { mobileApps } from './config';
import { MobileAppType } from './types';

import s from './AppLink.module.scss';

type AppLinkProps = {
  type: MobileAppType;
  className?: string;
};

const AppLink: React.FC<AppLinkProps> = ({ type, className }) => {
  const { url, Icon } = mobileApps[type];
  const { isOpen: isAccessibilityMode } = accessibilityParamsStore;

  return (
    <BaseClickable className={cn(s.appLink, className)} element="a" href={url}>
      <Icon className={cn(isAccessibilityMode && s.appLink__icon_accessibility)} />
    </BaseClickable>
  );
};

export default observer(AppLink);
